import React, { ReactElement } from 'react';
import { Price } from '../../../PaymentGateway/interfaces/Price';
import { ShopProduct, WithPrice } from '../../shared/interfaces';
import {
  PremiumPlanData,
  PremiumTemplateData,
} from '../../../../store/premium/reducer';
import { PremiumBundle } from '../components/PremiumBundle';
import { FullDate } from '../../Tip/interfaces/FullDate';

export enum PremiumProductNames {
  SEVEN_DAYS = 'Premium_7_Web',
  THIRTY_DAYS = 'Premium_30_Web',
  NINETY_DAYS = 'Premium_90_Web',
}

export class PremiumProduct extends ShopProduct implements WithPrice {
  component: ReactElement<{}>;
  price: Price;
  priceWithDiscount: Price;
  discountPercentage: number;
  plan: PremiumPlanData;
  template: PremiumTemplateData;
  expiresAt: FullDate;
  readonly totalPlanDays: number;
  readonly afterPurchaseExpirationDate: FullDate;

  constructor(plan: PremiumPlanData, template: PremiumTemplateData) {
    super();

    this.plan = plan;
    this.component = this.setComponent();
    this.template = template;
    this.price = new Price(
      plan.web_price.amount,
      plan.web_price.currency,
      plan.web_price.decimals,
    );
    this.priceWithDiscount = new Price(
      plan.web_price_with_discount.amount,
      plan.web_price_with_discount.currency,
      plan.web_price_with_discount.decimals,
    );
    this.discountPercentage = plan.web_discount_percentage;
    this.expiresAt = new FullDate(plan.expires_at);
    this.totalPlanDays = this.expiresAt.getDaysDifference(
      new FullDate(new Date().toISOString()),
    );
    this.afterPurchaseExpirationDate = this.expiresAt.addDays(
      plan.duration_days,
    );
  }

  public getProductName(): string {
    return PremiumProductNames[this.template.code];
  }

  public getPricingTierCodeNumber(): string {
    const parsedCode = this.plan.pricing_tier_code.split('.');
    const code = parsedCode[parsedCode.length - 1];

    return code.includes('tier') ? code.replace('tier', '') : code;
  }

  private setComponent(): ReactElement<{}> {
    return <PremiumBundle product={this} />;
  }
}
